import { Input, inject, OnInit, Signal, Component, input } from '@angular/core';
import { WebsiteStateService } from '../../../state-management/services/website-state.service';
import { ElementsType } from '../../../state-management/model/enums/state.enums';


@Component({
    template: '',
    standalone: false
})  
export abstract class CBaseComponent implements OnInit {
  readonly componentId = input<string>('');
  @Input() singleLabels: ElementsType[] = [];
  @Input() groupLabels: ElementsType[] = [];

  protected stateService = inject(WebsiteStateService);

  public elementSignals: Record<string, Signal<string[]>> = {};
  public groupElementSignals: Record<string, Signal<string[][]>> = {};
  public isEditMode$: Signal<boolean> = this.stateService.isEditMode;

  ngOnInit(): void {
    this.initializeSingleSignals();
    this.initializeGroupSignals();
  }

  private initializeSingleSignals(): void {
    this.singleLabels.forEach(label => {
      this.elementSignals[label] = this.stateService.getSingleComposedElementIds(this.componentId(), label);
    });
  }
  private initializeGroupSignals(): void {
    this.groupLabels.forEach(groupType => {
      this.groupElementSignals[groupType] = this.stateService.getGroupComposedElementIds(this.componentId(), groupType);
    });
  }
}
